import { render, staticRenderFns } from "./infodes.vue?vue&type=template&id=bbc94a66&scoped=true&"
import script from "./infodes.vue?vue&type=script&lang=js&"
export * from "./infodes.vue?vue&type=script&lang=js&"
import style0 from "./infodes.vue?vue&type=style&index=0&id=bbc94a66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc94a66",
  null
  
)

export default component.exports